import type { ExactCommentSocialData } from 'src/generated/gql/graphql';

import { getLocale } from '../config/globalStates';

export const getNewCreationDate = () => ({
  label: '',
  shortLabel: 'just now',
  longLabel: 'just now',
  shortAbsoluteLabel: new Date().toLocaleDateString(getLocale(), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }),
  longAbsoluteLabel: new Date().toLocaleDateString(getLocale(), {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }),
  dateTimeUtc: new Date().toISOString(),
  dateTime: new Date().toISOString(),
  seekMaxPollLabel: '',
});

export const getNewExactSocialData = (): ExactCommentSocialData => ({
  __typename: 'ExactCommentSocialData',
  likeCount: {
    __typename: 'SocialMetric',
    count: 0,
    label: '0',
  },
  replyCount: {
    __typename: 'SocialMetric',
    count: 0,
    label: '0',
  },
});
